<template lang="pug">
  div.lmm-content-body-padded
    sub-header
    b-container(fluid)
      b-row
        b-card.w-100(no-body)
          b-container(slot="header", fluid)
            b-row
              b-col(cols="2")
                datepicker(
                  :value="range.start",
                  :bootstrap-styling="true",
                  format="yyyy-MM-dd",
                  :language="range.lang",
                  @selected="startDateChanged")
              b-col(cols="2")
                datepicker(
                  :value="range.end",
                  :bootstrap-styling="true",
                  format="yyyy-MM-dd",
                  :language="range.lang",
                  :disabledDates="range.disabledDates",
                  @selected="endDateChanged")
              b-col(cols="2")
                b-form-select(v-model="filter.key", :options="filter.options", size="sm", @change="keyChangeHandler")
              b-col(cols="2")
                template(v-if="filter.key === 'type'")
                  b-form-select(v-model="filter.value", :options="filter.typeOptions", size="sm")
                template(v-else-if="filter.key === 'code'")
                  b-form-select(v-model="filter.value", :options="filter.codeOptions", size="sm")
                template(v-else)
                  b-form-input(v-model="filter.value", size="sm", @keydown.enter="tableRefresh")
              b-col(cols="2")
                b-button(size="sm", @click="tableRefresh") {{$t('search')}}
              b-col.ml-auto.text-right(cols="2")
                b-button(size="sm", variant="info", :disabled="!excelLoaded", @click="downloadExcel") EXCEL
          b-table(
            ref="dataTable",
            :fields="fields",
            :items="items",
            :current-page="page.current",
            :per-page="page.per",
            :show-empty="true",
            tbody-class="lmm-table-body",
            :empty-text="$t('no-content')")
            template(slot="HEAD_device", slot-scope="data")
              | {{$t('device')}}
            template(slot="HEAD_generate", slot-scope="data")
              | {{$t('event_time')}}
            template(slot="HEAD_device_os", slot-scope="data")
              | {{$t('device')}} OS
            template(slot="HEAD_alert", slot-scope="data")
              | {{$t('alert_message')}}
            template(v-slot:cell(alert)="row")
              span {{row.item.alert_code | alertName('label')}}
              span &nbsp;({{row.item.alert_value}})
            template(v-slot:cell(generate)="row")
              | {{row.item.generate | moment('YY-MM-DD HH:mm:ss')}}
            template(v-slot:cell(device_os)="row")
              icon(:name="getOS(row.item.device_os_id)")
          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )
</template>

<script>
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"
import { AnalysticAPI } from "../../api"

export default {
  name: "log-warning-component",
  components: { Datepicker },
  methods: {
    downloadExcel() {
      if (this.excelLoaded && this.excelLink) {
        location.href = this.excelLink
      }
    },
    keyChangeHandler() {
      this.filter.value = ""
    },
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    tableRefresh() {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    getOS(id) {
      switch (id) {
        case 1:
          return "windows"
        default:
          return "windows"
      }
    },
    items(ctx) {
      let params = {
        by: "create_time",
        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: "desc",
        export_id: "alertHistoryTable",
      }
      if (this.filter.value) {
        params.search_key = this.filter.key
        params.search_value = this.filter.value
      }
      AnalysticAPI.excel.post("", params).then(resp => {
        if (!resp.data.objects.length) {
          const downloadUrl = resp.data.objects.download_url
          const fileName = resp.data.objects.file_name
          this.excelLink = `${this.AppState.Path.origin}${downloadUrl}/${fileName}`
          this.excelLoaded = true
        } else {
          this.excelLink = null
          this.excelLoaded = false
        }
      })
      return AnalysticAPI.history.get("alert", { params }).then(resp => {
        this.page.total = resp.data.meta.total_count
        return resp.data.objects
      })
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      excelLoaded: false,
      excelLink: null,
      range: {
        start: new Date().setDate(-1),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      fields: [
        { key: "device", label: this.$t("device") },
        { key: "generate", label: this.$t("event_time") },
        {
          key: "device_os",
          label: "O/S",
          tdClass: "text-center",
          thClass: "text-center",
        },
        { key: "alert", label: this.$t("alert_message") },
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      filter: {
        key: "alias",
        value: "",
        options: [
          { text: this.$t("name"), value: "alias" },
          { text: "OS", value: "type" },
          { text: this.$t("threshold"), value: "code" },
        ],
        typeOptions: [
          { text: this.$t("please_select"), value: "" },
          { text: this.$t("windows"), value: 1 },
          { text: this.$t("linux"), value: 2 },
          { text: this.$t("mac"), value: 3 },
          { text: this.$t("android"), value: 4 },
          { text: this.$t("ios"), value: 5 },
        ],
        codeOptions: [
          { text: this.$t("please_select"), value: "" },
          { value: 1, text: "Disconnected" },
          { value: 2, text: "CPU Usage" },
          { value: 3, text: "Memory Usage" },
          { value: 4, text: "Disk Usage" },
          { value: 5, text: "CPU Temperature" },
          { value: 6, text: "Disk Temperature" },
          { value: 7, text: "Fan Speed" },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped></style>
